export const TEXT_SUGGESTIONS_QUERY = `
query TextSuggestionsQuery(
  $limit: Int
  $sort: TextSuggestionSort
  $type: TextSuggestionQueryType
) {
  public {
    textSuggestions(limit: $limit, sort: $sort, type: $type) {
      text
      id
    }
  }
}
`;
